function setAltTags() {
  $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
  $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
}
jQuery(document).ready(function($) {
  $('button[type="submit"].tt-btn-search').append('<span style="display:none;">.</span>');
  $('button.tt-btn-close.icon-f-84').append('<span style="display:none;">.</span>');
  $('button[type="button"].close[data-dismiss="modal"]').append('<span style="display:none;">.</span>');
  $('input.notify-pn-bk-stock-input-email').attr('aria-label', 'Enter email address');
  $('input.notify-pn-bk-stock-input-name').attr('aria-label', 'Enter your name');
  $('input.notify-pn-bk-stock-input-phone').attr('aria-label', 'Enter phone number');
  $('img[data-src="//www.turmerry.com/cdn/shop/files/Early-Access-Black-Friday-Sale-mega-menu_560x.jpg?v=1762405162"]').attr('alt', 'Early Access Black Friday Sale');
  $('a[href="/collections/black-friday-mattress-sale"]').attr('aria-label', 'View Black Friday mattress sale collection');

  $("div#shopify-section-template--17882189660269__main label.rbr-checkbox-label-container").attr("aria-label","Select checkbox to combine in bundle");
  // Set aria-label for the first image
  $('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Sleep_Hygiene-Key_to_Healthy_Sleep-main_image_respimgsize.jpg?v=1722243452"]').parent('a').attr('aria-label', 'Sleep Hygiene: Key to Healthy Sleep');
  $('div.stamped-reviews-title>a').attr("aria-label","review title");
  $('a[href="/collections/best-fall-mattress-sale"]').attr('aria-label', 'Best fall mattress sale collection');
  $("h3:empty").append("<span style='display:none'>.</span>")
  let Intervaltime_task;
  let counter_task = 0;

  try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
  }
  catch (err) {

  }

  function GenerateAriaLabelFortask() {

    counter_task++;

    if ($("div.stamped-visual-gallery-media-block>a").length) {

      $('div.stamped-reviews-title>a').attr("aria-label","review title");
      $("div.stamped-visual-gallery-media-block>a").attr("aria-label","review title");
      $("a[onclick^='StampedWallPhotosFn']").attr("aria-label","play button");
      clearInterval(Intervaltime_task);

    }

    if (counter_task >= 20) {
      clearInterval(Intervaltime_task);

    }
  }

  // Set aria-label for the second image
  $('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Master_bedroom_ideas-main-image_respimgsize.jpg?v=1719323887"]').parent('a').attr('aria-label', 'Master bedroom ideas');
  // Set aria-label for the first image
  $('img[data-mainimage="//www.turmerry.com/cdn/shop/articles/Sleep_Hygiene-Key_to_Healthy_Sleep-main_image_respimgsize.jpg?v=1722243452"]').parent('a').attr('aria-label', 'Sleep Hygiene: Key to Healthy Sleep');
  $("h3.t_ft_blog_h3:empty").append('<span style="display:none;">.</span>');
  $("h3.t_ft_blog_h3>strong:empty").append('<span style="display:none;">.</span>');

  $("h4:empty").append('<span style="display:none;">.</span>');
  $("table.tt_mt_comp_table thead tr th:first:empty").append("<span style='display:none;'>.</span>");

  $("a[href='https://www.turmerry.com/blogs/dreamerry/latex-mattress-guide-all-questions-answered']").attr("aria-label", "Latex Mattress Guide - All Questions Answered");
  $("a[href='https://www.turmerry.com/blogs/dreamerry/how-to-sleep-on-your-stomach']").attr("aria-label", "How to Sleep on Your Stomach");
  $("label[for='loginInputName']").removeAttr("for");

  $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
  $('a[href="#stamped-main-widget"]').attr("aria-label","stamped main widget");
  $("div.tt-aside-subscribe-box form.kl-private-reset-css-Xuajs1 button").each(function() {
    var link = $(this);
    var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
  });
  $("h2:empty").append("<span style='display:none'>.</span>")
  let Intervaltime_google;
  let counter_google = 0;

  try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
  }
  catch (err) {

  }

  function GenerateAriaLabelForGoogle() {

    counter_google++;

    $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
    $("input[class^='horizontalBundleItems_checkbox']").attr("aria-label","Select checkbox to frequently bought together item");
    $("#\\33 88860").attr("aria-label","select option");
    $("#\\33 88861").attr("aria-label","select option");
    $("#\\33 402804").attr("aria-label","select option");
    if ( $('#goog-gt-votingInputSrcLang').length) {
      $("label.adb-switch").append('<span style="display:none">.</span>');

      $('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
      $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
      $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
      $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
      $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');

      clearInterval(Intervaltime_google);

    }

    if (counter_google >= 20) {
      clearInterval(Intervaltime_google);

    }
  }

  setTimeout(function() {
    $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
    $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
    $("input[class^='horizontalBundleItems_checkbox']").attr("aria-label","Select checkbox to frequently bought together item");
    $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
    $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
  }, 1000);

  console.log( "ready!" );

  let Intervaltime_checkbox;
  let counter_checkbox = 0;

  try {
    Intervaltime_checkbox = setInterval(GenerateAriaLabelForPopup_checkbox, 500);
  }
  catch (err) {

  }

  function GenerateAriaLabelForPopup_checkbox() {

    counter_checkbox++;
    if ($('label.rbr-checkbox-label-container').length) {

      $('label.rbr-checkbox-label-container').attr("aria-label", "Select checkbox to frequently bought together item");
      $('div#rbr-bundle-355421 label.rbr-checkbox-label-container').attr("aria-label", "Select checkbox to frequently bought together item");

      clearInterval(Intervaltime_checkbox);
    }

    if (counter_checkbox >= 30) {
      clearInterval(Intervaltime_checkbox);
    }
  }

  let Intervaltime3;
  let counter = 0;

  try {
    Intervaltime3 = setInterval(GenerateAriaLabelForPopup, 500);
  }
  catch (err) {

  }

  function GenerateAriaLabelForPopup() {
    $('#517833[data-rbrselector="discountInfoV1RadioButton"]').attr('aria-label', 'Select bundle discount');
    $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
    $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
    counter++;
    $('div#rbr-bundle-354990 label.rbr-checkbox-label-container').attr("aria-label","Select checkbox to frequently bought together item");
    $('div#rbr-bundle-355421 label.rbr-checkbox-label-container').attr("aria-label","Select checkbox to frequently bought together item");

    $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
    if ($("#stamped-reviews-tab").length) {
      $("h3.stamped-review-header-title:empty").append("<span style='display:none'>.</span>");
      clearInterval(Intervaltime3);

    }

    if (counter >= 10) {
      clearInterval(Intervaltime3);

    }
  }

  let Intervaltime1;
  let counter1 = 0;

  try {
    Intervaltime1 = setInterval(GenerateAriaLabelForPopup1, 500);
  }
  catch (err) {

  }

  function GenerateAriaLabelForPopup1() {
    counter++;
    $('div[class^="info_radioBtnContainer"] input[type="radio"]').attr('aria-label', 'Select radio option');

    $("a.stamped-review-title").attr("aria-label","review title");
    if ($('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').length) {
      $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');
      $("div.needsclick.kl-private-reset-css-Xuajs1>div>h1>span:empty").append('<span style="display:none;">.</span>');

      clearInterval(Intervaltime1);
    }

    if (counter >= 10) {
      clearInterval(Intervaltime1);
    }
  }

  setAltTags();

  setTimeout(setAltTags, 1000);
});

document.addEventListener("DOMContentLoaded", (event) => {
  $('picture source[srcset*="Prime_Week_Sale"]').siblings('img.removelazyload').attr('alt', 'Turmerry Prime Week Sale banner');

  $('img[data-src="//www.turmerry.com/cdn/shop/files/Prime_Week_Sale-mega-menu-banner_560x.jpg?v=1781764007"]').attr('alt', 'Turmerry Prime Week Sale banner');
  $('a[href="/collections/prime-week-sale"]').attr('aria-label', 'Shop Prime Week Sale');
  $("div.tt-aside-subscribe-box form.kl-private-reset-css-Xuajs1 button").each(function() {
    var link = $(this);
    var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
    link.html(spanElement);
  });
  setTimeout(function(){
    $("div.kl-private-reset-css-Xuajs1 h1>span:empty").append('<span style="display:none;">.</span>');
    $("div.kl-private-reset-css-Xuajs1 h1").append('<span style="display:none;">.</span>');
    $("input[class^='horizontalBundleItems_checkbox']").attr("aria-label","Select checkbox to frequently bought together item");
    $('img[src="//www.turmerry.com/cdn/shop/files/Fall-Sale-2025-mega-menu-3_560x.jpg?v=1760098614"]').attr('alt', 'Fall sale 15% off');
    $('input[type="radio"][name^="discountOption"]').attr('aria-label', 'Select discount option');

    $('div.rbr-checkbox__container input[type="checkbox"]').attr('aria-label', 'Select checkbox option');
    $("h3.stamped-review-header-title:empty").append("<span style='display:none'>.</span>");
    $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/LZ2qsF/images/7888526e-7c62-4525-b69a-1738fbc30847.png"]').attr('alt', 'turmerry mattress');

  });
});
$('#517833[data-rbrselector="discountInfoV1RadioButton"]').attr('aria-label', 'Select bundle discount');